import fetchInterceptor ,{FetchOptions} from "../../../utils/fetchInterceptor ";
// import fetchInterceptor, { FetchOptions } from "../../../utils/fetchInterceptor";
import { blogEndpoints } from "../apiEndpoints";



const UpdateBlogAPI = async (id: string, blogData: FormData) => {
    const url = blogEndpoints.update(id)
    const options: FetchOptions = {
      method: "PUT",
  
      body: blogData, // Pass the FormData object directly
    };
    return fetchInterceptor(url, options);
  };

export default UpdateBlogAPI;
